import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import
{

    INewImmigration,
    IImmigration,
    IImmigrationResponse,
    INewEmployeeI9Document,
    IEmployeeI9Document
} from "./immigration.interface";
import { IHttpRequestConfig } from "../http";
import { createFormData } from "../util/utilities";

/**
 * 
 */

export class ImmigrationDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getAllEmployeeI9AndEVerfiy(orgId: string, filterEmployee: string, filterCode: string): Observable<IImmigrationResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId,
                FilterEmployee: filterEmployee,
                FilterCode: filterCode
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.IMMIGRATION.GET_ALL_IMMIGRATION, null, config).pipe(
            map((response: any) =>
            {
                return {
                    immigrations: this.normalizeImmigrations(response.data.employeeI9AndEVerifies || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public getEmployeeI9AndEVerfiyById(immigrationId: string): Observable<IImmigrationResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                EmployeeI9andEverifyId: immigrationId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.IMMIGRATION.GET_IMMIGRATION_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    immigration: this.normalizeImmigration(response.data.employeeI9AndEVerify || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewImmigration(newImmigration: INewImmigration): Observable<IImmigrationResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.IMMIGRATION.CREATE_IMMIGRATION, newImmigration).pipe(
            map((response: any) =>
            {
                return {
                    immigrations: this.normalizeImmigrations(response.data.employeeI9AndEverifyData || []),
                    employeeI9andEverifyId: response.data.newEmployeeI9AndEVerifyId,
                    success: response.data.success

                };
            }),
            share());
    }

    public updateImmigration(immigration: IImmigration): Observable<IImmigrationResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.IMMIGRATION.UPDATE_IMMIGRATION, immigration).pipe(
            map((response: any) =>
            {
                return {
                    immigrations: this.normalizeImmigrations(response.data.employeeI9AndEVerifies || []),
                    employeeI9andEverifyId: immigration.employeeI9andEverifyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createI9Contracts(documents: INewEmployeeI9Document): Observable<IImmigrationResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.IMMIGRATION.CREATE_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    immigrations: this.normalizeImmigrations(response.data.employeeI9AndEVerifies || []),
                    employeeI9andEverifyId: documents.employeeI9andEverifyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateI9Contracts(documents: INewEmployeeI9Document): Observable<IImmigrationResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.IMMIGRATION.UPDATE_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    immigrations: this.normalizeImmigrations(response.data.employeeI9AndEVerifies || []),
                    employeeI9andEverifyId: documents.employeeI9andEverifyId,
                    success: response.data.success
                };
            }),
            share());
    }

    private normalizeImmigrations(immigration: any): IImmigration[]
    {
        return immigration.map(immigration =>
        {
            return this.normalizeImmigration(immigration);
        });

    }

    private normalizeImmigration(immigration: any): IImmigration
    {

        return {
            ...immigration,
            employeeFullName: immigration.employee ? immigration.employee.employeeFullName : '',
            employeeI9andEverifyDocuments: this.normalizeDocuments(immigration.employeeI9andEverifyDocuments ?
            immigration.employeeI9andEverifyDocuments : [])
            // employeeI9andEverifyDocument: this.normalizeDocuments(immigration.employeeI9andEverifyDocument ?
                // immigration.employeeI9andEverifyDocument : [])
        };

    }

    private normalizeDocuments(docs: any): IEmployeeI9Document
    {
        return docs.map(doc =>
        {
            return {
                employeeI9andEverifyDocumentId: doc.employeeI9andEverifyDocumentId,
                fileName: doc.fileName,
                employeeI9DocType: doc.configuration ? doc.configuration.configurationValue : '',
                employeeI9DocTypeId: doc.configurationId,

                fileLocationPath: doc.fileLocationPath,
                fileExpiryDateToString: doc.fileExpiryDateToString
            };
        });
    }
}